var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ShippingEligibilityInfo", { ref: "eligibility" }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "el-row",
            { staticClass: "form-row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "label",
                    [
                      _vm._v("\n          Reason Group\n          "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "Refresh data",
                            placement: "top",
                          },
                        },
                        [
                          _c("RefreshButton", {
                            staticClass: "flex-shrink",
                            staticStyle: { padding: "0" },
                            attrs: { text: false },
                            on: { click: _vm.refreshReasons },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { margin: "5px 0px" },
                    attrs: {
                      value: _vm._f("capitalize")(
                        _vm.getReasonGroup(_vm.request_reasons.reason_group).key
                      ),
                      readonly: "",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, max: 10 },
                    model: {
                      value: _vm.new_reason.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_reason, "quantity", $$v)
                      },
                      expression: "new_reason.quantity",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 18 } },
                [
                  _c(
                    "el-select",
                    {
                      ref: "reason",
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        disabled: _vm.currentReasons.length < 1,
                        placeholder: "Select part",
                      },
                      on: { change: _vm.partShippingEligibility },
                      model: {
                        value: _vm.new_reason.id,
                        callback: function ($$v) {
                          _vm.$set(_vm.new_reason, "id", $$v)
                        },
                        expression: "new_reason.id",
                      },
                    },
                    _vm._l(_vm.currentReasons, function (reason) {
                      return _c(
                        "el-option",
                        {
                          key: reason.id,
                          staticStyle: { height: "3rem" },
                          attrs: {
                            disabled:
                              _vm.partRestricted(reason.id) ||
                              reason.out_of_stock,
                            label: reason.text,
                            value: reason.id,
                          },
                        },
                        [
                          _c("div", { staticClass: "part-option-row" }, [
                            _c("span", [_vm._v(_vm._s(reason.text))]),
                            _vm._v(" "),
                            reason.out_of_stock
                              ? _c("span", { staticClass: "oos-inline" }, [
                                  _vm._v(
                                    "\n                — Out of stock\n              "
                                  ),
                                ])
                              : reason.estimated_delivery
                              ? _c(
                                  "span",
                                  { staticClass: "estimated-delivery-inline" },
                                  [
                                    _vm._v(
                                      "\n                — " +
                                        _vm._s(reason.estimated_delivery) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.request_reasons.reasons },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Quantity", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tag", [_vm._v(_vm._s(scope.row.quantity))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Part" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.getReason(scope.row.id).text
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Sku", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getReason(scope.row.id).sku) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Estimated Delivery", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.estimated_delivery || "—") +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeNewReason(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            Delete\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "center-buttons" },
            [
              _c(
                "el-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.back()
                    },
                  },
                },
                [_vm._v("\n        Back\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "info", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.reset()
                    },
                  },
                },
                [_vm._v("\n        Reset\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { disabled: !_vm.isValid, type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      return _vm.next()
                    },
                  },
                },
                [_vm._v("\n        Next\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }